import React from "react";
import AonPannel from "../../components/core/AonPannel";
import { observer } from 'mobx-react';
import { useMarketDetailsStore } from "../../store";
import { Link } from "react-router-dom";
export var MarketIntermediaries = observer(function () {
    var marketDetailsStore = useMarketDetailsStore();
    var MarketIntermediariesBody = observer(function () {
        return React.createElement("div", null,
            React.createElement("div", { style: { fontWeight: "bold", fontSize: "18px" } }, "Market Name"),
            marketDetailsStore.Intermediaries.map(function (item, index) {
                var navigationLink = "/market-details?MarketId=" + (item === null || item === void 0 ? void 0 : item.intermediariesMarketId);
                return React.createElement("div", { style: { paddingBlock: "5px" } },
                    React.createElement(Link, { to: navigationLink, target: '_blank' },
                        React.createElement("div", { key: index, className: "marketDetailsTextDecoration" }, item.intermediariesMarketName)));
            }));
    });
    return marketDetailsStore.Intermediaries.length > 0 ? React.createElement(AonPannel, { headerTitle: "Intermediaries", Body: React.createElement(MarketIntermediariesBody, null) }) : React.createElement(React.Fragment, null);
});
